// extracted by mini-css-extract-plugin
export default {"main":"ContainersPage_main__1qENn","whyUsText":"ContainersPage_whyUsText__kMlA8","headerPr":"ContainersPage_headerPr__+plus","whyUs":"ContainersPage_whyUs__-H23W"};